import { authenticatedFetch } from "./base";

export const getOverdueOperations = () => {
  return authenticatedFetch(`/api/lambdaoperations/overdueoperations`, {
    method: "get",
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (response) {
      return response;
    });
};
